<template>
  <div class="companyListView-all-box">
    <card>
      <form-table-page
        class="index-all-box"
        :data="formData"
        :label="formLabel"
        @Query="Query"
        @Reset="Reset"
      >
        <template slot="companyName">
          <el-input v-model="formData.companyName" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="technicalArea">
          <el-select v-model="formData.technicalArea" :placeholder="$t('queryForm.pleaseSelect')">
            <el-option v-for="(item, index) in selectInfoObj.technicalArea" :key="'technicalArea' + index" :label="item.value" :value="item.key" />
          </el-select>
        </template>

        <template slot="headQuarter">
          <el-cascader v-model="formData.headQuarter" :props="{value:'areaNo', label: 'name', children: 'underCity'}" :options="selectInfoObj.headQuarter" :placeholder="$t('queryForm.pleaseSelect')" />
        </template>

        <template slot="companyContactPerson">
          <el-input v-model="formData.companyContactPerson" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>
        <!-- 是否启用：启用/禁用 -->
        <!-- <template slot="isAvaliable">
          <el-select
            v-model="formData.isAvaliable"
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
          >
            <el-option :label="$t('queryForm.enable')" value="0" />
            <el-option :label="$t('queryForm.disable')" value="1" />
          </el-select>
        </template> -->
      </form-table-page>
    </card>

    <card style="margin-top: 10px">
      <div class="table-content-box">
        <div class="btn-list-box form-btn-list">
          <cus-btn v-if="buttonPerCheck('add')" type="add" @click="openEditAdd('add')" />
          <!-- <cus-btn v-if="buttonPerCheck('enable')" type="enable" @click="setCompanyEnableDisable(0)" />
          <cus-btn v-if="buttonPerCheck('disable')" type="disable" @click="setCompanyEnableDisable(1)" /> -->
          <cus-btn v-if="buttonPerCheck('delete')" type="delete" @click="companyDelete" />

          <div v-if="buttonPerCheck('import')" style="float:right">
            <el-button type="text" style="margin-left:20px" @click="downloadTemplate">{{ $t("button.importTemplateDownload") }}</el-button>
            <cus-btn type="import" :loading="importLoading" @click="openImportPage()" />
          </div>
        </div>

        <table-page
          :table-data="tableData"
          :change-fun="handleSearch"
          :current-page="pageNum"
          :total="total"
          @selectionChange="handleSelectionChange"
        >
          <template slot="tableItem">
            <el-table-column
              prop="companyCode"
              :label="$t('formData.companyCode')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            />

            <el-table-column
              prop="companyName"
              :label="$t('formData.companyName')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            />

            <el-table-column
              prop="technicalAreaName"
              :label="$t('formData.technicalArea')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            />

            <el-table-column
              prop="headQuarterList"
              :label="$t('formData.headQuarter')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            />

            <el-table-column
              prop="companyContactPerson"
              :label="$t('formData.companyContactPerson')"
              align="center"
              min-width="200"
              show-overflow-tooltip
            />

            <!-- <el-table-column
              prop="isAvaliableName"
              :label="$t('formData.isAvaliable')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            /> -->

            <el-table-column
              prop="projectCount"
              :label="$t('formData.projectCount')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-link v-if="scope.row.projectCount" :underline="false" type="primary" @click="goProjectListView(scope.row.companyName)">{{ scope.row.projectCount }}</el-link>
                <div v-if="!scope.row.projectCount">{{ scope.row.projectCount }}</div>
              </template>
            </el-table-column>

            <el-table-column
              class-name="tabAction"
              :label="$t('formData.action')"
              align="center"
              width="100"
              fixed="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-dropdown @command="actionHandler">
                  <span class="el-dropdown-link">
                    <!-- {{$t('formData.action')}}<i class="el-icon-arrow-down el-icon--right"></i> -->
                    <i class="el-icon-ali-TechnicalArea"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="buttonPerCheck('view')" :command="{action:'openViewPage',param:[scope.row.id]}" >{{ $t('button.view') }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('edit')" :command="{action:'openEditAdd',param:['edit',scope.row.id]}" >{{ $t('button.edit') }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('viewProcess')" :command="{action:'openProcessListViewPage',param:[scope.row.id]}" >{{ $t('button.viewProcess') }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('editProcess')" :command="{action:'openProcessListPage',param:[scope.row.id]}" >{{ $t('button.editProcess') }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('delete')" :command="{action:'companyDeleteOne',param:[scope.row.id]}" >{{ $t("button.delete") }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('generate')" :command="{action:'generateCompanyPDF',param:[scope.row.id]}" >{{ $t('button.generate') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </template>
        </table-page>
      </div>
    </card>

    <el-dialog width="80%" :visible.sync="dialogVisible">
      <pdf-page ref="pdfPage" />
    </el-dialog>
  </div>
</template>

<script>
import pdfPage from '@/views/homes/pdfPage.vue'
import { companyList, companyEnableDisable, companyDelete, patentImport } from '../../api/companyManagement'
import { getSelectInfoAll, getAreaNoName, getSelectName } from '../../utils/companyManagement'
import { importExcelHelper } from '../../utils/excelImportHelper'
import axios from 'axios'
export default {
  components: {
    'pdf-page': pdfPage
  },
  data() {
    return {
      dialogVisible: false,
      multipleSelection: [],
      importLoading: false,
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      selectInfoObj: {},
      tipsList: {},
      queryData: {
        companyName: '',
        technicalArea: '',
        headQuarter: [],
        companyContactPerson: '',
        isAvaliable: ''
      },
      formData: {
        companyName: '',
        technicalArea: '',
        headQuarter: [],
        companyContactPerson: '',
        // isAvaliable: ''
      },
      formLabel: {
        companyName: 'queryForm.companyName',
        technicalArea: 'queryForm.technicalArea',
        headQuarter: 'queryForm.headQuarter',
        companyContactPerson: 'queryForm.companyContractPerson',
        // isAvaliable: 'queryForm.isAvaliable'
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    }
  },
  watch: {
    lang() {
      this.getSelectInfo()
    }
  },
  mounted() {
    const self = this
    window.companyListView = self
    self.getSelectInfo()
  },
  methods: {
    /**
     * 查询方法
     * @constructor
     */
    Query(type) {
      this.pageNum = 1
      this.queryData = this.formData
      this.queryCompanyList()
      //console.log('查询', type)
    },

    /**
     * 重置
     * @constructor
     */
    Reset() {
      // this.pageNum = 1
      // this.queryData = this.formData
      // this.queryCompanyList()
      //console.log('重置')
    },

    /**
     * 监听分页
     */
    handleSearch(currentPage, pageSize) {
      this.pageNum = currentPage
      this.pageSize = pageSize
      this.queryCompanyList()
      //console.log('22222', currentPage, pageSize)
    },

    /**
     * 调转到查看公司页面
     */
    openViewPage(companyId) {
      this.$router.push({
        name: 'companyInfoViewInList',
        query: {
          companyId,
          backToPage: 'companyListView'
        }
      })
    },

    /**
     * 调转到新增公司页面
     */
    openEditAdd(type, companyId) {
      this.$router.push({
        name: 'companyInformationViewInList',
        query: {
          type: type,
          companyId: companyId || '',
          backToPage: 'companyListView'
        }
      })
    },

    /**
     * table 选中事件
     * @param val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val
      //console.log('11111111', this.multipleSelection)
    },

    /**
     * 获取下拉框信息
     *  status 1 获取详情  0 不获取详情
     */
    getSelectInfo() {
      const self = this

      getSelectInfoAll(selectInfoObj => {
        self.selectInfoObj = selectInfoObj
        self.queryCompanyList()
      }, true)
    },

    /**
     * 查询公司列表
     */
    queryCompanyList() {
      const self = this
      const queryForm = { pageSize: self.pageSize, pageNum: self.pageNum, ...self.queryData }
      queryForm.headQuarter = self.queryData.headQuarter.toString()
      companyList(queryForm).then(response => { 
        if (response.code === 200) {
          self.tableData = []
          self.total = response.data.total

          if (response.data.list && response.data.list.length) {
            response.data.list.forEach(item => {
              // 技术领域  
              if (item.technicalArea && self.selectInfoObj && self.selectInfoObj.technicalArea.length) {
                item.technicalAreaName = getSelectName(item.technicalArea, self.selectInfoObj.technicalArea)
              }

              item.isAvaliableName = item.isAvaliable ? self.$t('formData.disable') : self.$t('formData.enable')

              // 公司总部
              if (item.headQuarter && self.selectInfoObj && self.selectInfoObj.headQuarter.length) {
                item.headQuarterList = getAreaNoName(item.headQuarter, self.selectInfoObj.headQuarter)
              }
            })
          }

          self.tableData = response.data.list
        }
      })
    },

    /**
     * 启用禁用公司
     */
    setCompanyEnableDisable(isAvaliable) {
      const self = this
      const param = {
        ids: [],
        isAvaliable
      }

      if (!self.multipleSelection.length) {
        self.$message.warning(isAvaliable ? self.$t('tipsList.companyToDisable') : self.$t('tipsList.companyToEnable'))
        return
      }

      self.multipleSelection.forEach(item => {
        param.ids.push(item.id)
      })

      companyEnableDisable(param).then(response => {
        if (response.code === 200) {
          self.queryCompanyList()
          self.$message.success(response.message)
        } else {
          self.$message.error(response.message)
        }
      })
    },

    /**
     * 删除公司
     */
    companyDelete(id) {
      const self = this

      if (!id && self.multipleSelection.length === 0) {
        self.$message.error(self.$t('tipsList.youWantToDelete'))
        return
      }
      // self.$confirm(
      //   self.$t('tipsList.deleteCompanyWill'),
      //   self.$t('messageCommon.tips'),
      //   {
      //     confirmButtonText: self.$t('button.confirm'),
      //     cancelButtonText: self.$t('button.cancel'),
      //     type: 'warning'
      //   }
      // )
      //   .then(() => {
      self.companyDeleteOne()
      // })
    },

    /**
     * 删除公司
     */
    companyDeleteOne(id) {
      const self = this
      let ids = []

      if (id) {
        ids = [id]
      } else {
        self.multipleSelection.forEach(item => {
          ids.push(item.id)
        })
      }

      self.$confirm(
        self.$t('tipsList.deleteCompanyWill'),
        self.$t('messageCommon.tips'),
        {
          confirmButtonText: self.$t('button.confirm'),
          cancelButtonText: self.$t('button.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          companyDelete({ ids }).then(response => {
            if (response.code === 200) {
              self.queryCompanyList()
              self.$message.success(self.$t('tipsList.deleteTheSuccess'))
            } else {
              self.$message.error(self.$t('tipsList.deleteFailed'))
            }
          })
        })
    },

    openImportPage() {
      // 打开导入界面
      importExcelHelper.call(this, file => {
        this.importData(file)
      })
    },

    /**
     * 导入数据
     */
    importData(file) {
      this.importLoading = true
      patentImport(file)
        .then(result => {
          if (result.code === 200) {
            this.$message({
              type: 'success',
              message: result.message
            })

            this.queryCompanyList()
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: this.$t('messageCommon.request') + this.$t('messageCommon.error')
          })
        })
        .finally(() => {
          this.importLoading = false
        })
    },

    /**
     * 下载导入模板
     */
    downloadTemplate() {
      const baseUrl = axios.defaults.baseURL
      const languageCur = this.$store.state.app.language
      let templateUrl = baseUrl// + '/file/template/CompanyTemplate.xlsx'
      if(languageCur === 'en'){
        templateUrl += '/file/template/CompanyTemplate_EN.xlsx'
      }
      else{
        templateUrl += '/file/template/CompanyTemplate_CN.xlsx'
      }

      window.open(templateUrl)
    },

    /**
    * 跳转到公司流程列表页面
    */
    openProcessListViewPage(id) {
      this.$router.push({
        name: 'companyProcessListViewView',
        query: {
          id: id,
          backToPage: 'companyListView'
        }
      })
    },

    /**
    * 跳转到公司流程列表页面
    */
    openProcessListPage(id) {
      this.$router.push({
        name: 'companyProcessListView',
        query: {
          id: id,
          backToPage: 'companyListView'
        }
      })
    },

    /**
    * 跳转到项目列表页面
    */
    goProjectListView(companyName) {
      this.$router.push({
        name: 'projectListView',
        query: {
          companyName
        }
      })
    },

    /**
     * 生成pdf
     */
    generateCompanyPDF(companyId) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.pdfPage.init(companyId)
      })
    },

    actionHandler(command){
      switch(command.action){
        case 'openViewPage':
          this.openViewPage(command.param[0])
          break;
        case 'openEditAdd':
          this.openEditAdd(command.param[0],command.param[1])
          break;
        case 'openProcessListViewPage':
          this.openProcessListViewPage(command.param[0])
          break;
        case 'openProcessListPage':
          this.openProcessListPage(command.param[0])
          break;
        case 'companyDeleteOne':
          this.companyDeleteOne(command.param[0])
          break;
        case 'generateCompanyPDF':
          this.generateCompanyPDF(command.param[0])
          break;
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .companyListView-all-box {
    .tabAction {
      .el-tooltip {
        white-space: inherit;
      }
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

</style>
